var bookshelf = require("../index");

module.exports = bookshelf.model("TableHeaderType", {
  tableName: "table_header_type",

  parse(res) {
    if (res.columns) res.columns = JSON.parse(res.columns);
    if (res.settings) res.settings = JSON.parse(res.settings);
    return res;
  },
});
